
































import {Component, Vue} from 'vue-property-decorator';
import {Action, State} from "vuex-class";
import {BucketDir} from "@/store/types";
import {LOAD_FILE_ACTION, MOVE_TO_ACTION, OPEN_FOLDER_ACTION} from "@/store/actions";

@Component({})
export default class Index extends Vue {
    @Action(LOAD_FILE_ACTION) public loadFile!: any;
    @Action(OPEN_FOLDER_ACTION) public openFolder!: any;
    @Action(MOVE_TO_ACTION) public moveTo!: any;

    @State('nodesStack') public nodesStack!: BucketDir[];

    public currentNode() {
        return this.nodesStack.length ? this.nodesStack[this.nodesStack.length - 1] : null;
    }

    public formatDate(dt: Date) {
        const dayNumber = dt.getDate();
        const dayNumberLex = dayNumber < 10 ? `0${dayNumber}` : `${dayNumber}`;
        const monthNumber = dt.getMonth() + 1;
        const monthNumberLex = monthNumber < 10 ? `0${monthNumber}` : `${monthNumber}`;
        return `${dayNumberLex}.${monthNumberLex}.${dt.getFullYear()}`
    }
}
